import { Component, inject, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { LogoFileType, LogoLocation, ThemeService } from "@core";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "@shared";
import { WhiteLabelService } from "app/core/white-label/white-label.service";
import { ButtonComponent } from "app/shared/components/button/button.component";
import { FooterComponent } from "app/shared/components/footer/footer.component";
import { environment } from "environments/environment";

@Component({
  selector: "insufficient-permissions",
  templateUrl: "./insufficient-permissions.component.html",
  styleUrls: ["./insufficient-permissions.component.scss"],
  imports: [MatIconModule, ButtonComponent, FooterComponent, TranslateModule],
})
export class InsufficientPermissionsComponent implements OnInit {
  private loaderService = inject(LoaderService);
  private whiteLabelService = inject(WhiteLabelService);
  private themeService = inject(ThemeService);

  public location: string = "insufficient-permissions";
  public logoSrc: string;

  constructor() {
    this.loaderService.hide();
  }

  ngOnInit() {
    const customLogoData: LogoLocation | undefined =
      this.whiteLabelService.getCustomLogo(this.location);
    if (customLogoData?.hide) {
    } else {
      const logoFilename: string | undefined = customLogoData
        ? customLogoData.name
        : "logo";
      const logoFileType: LogoFileType | undefined = customLogoData?.fileType
        ? customLogoData!.fileType
        : "svg";
      this.logoSrc = `${this.themeService.assetPath}/logo/${logoFilename}.${logoFileType}`;
    }
  }

  public goToUserProfileApplication() {
    if (!!environment.production) {
      window.location.href = this.whiteLabelService.data.userProfileLink;
    } else {
      window.location.href = "https://id-test.cloudya.com";
    }
  }
}
